// The page's random source: seeded when ?seed=N is given so sound variation repeats exactly.
import { rng } from '../world/environment/layout';

export function randomSource(seed: number | null): () => number {
  return seed === null ? Math.random : rng(seed);
}
